import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MainComponent } from './main.component';

const routes: Routes = [{
  path: '',
  component: MainComponent,
  children: [
    {
      path: '',
      redirectTo: 'new-sales-dashboard',
      pathMatch: 'full'
    },
    {
      path: 'search',
      loadChildren: () => import('./search/search.module').then(m => m.SearchModule)
    },
    {
      path: 'quoting',
      loadChildren: () => import('./quoting/quoting.module').then(m => m.NewSalesModule)
    },
    {
      path: 'renewal',
      loadChildren: () => import('./renewal/renewal.module').then(m => m.RenewalModule)
    },
    {
      path: 'new-sales-dashboard',
      loadChildren: () => import('./new-sales-dashboard/new-sales-dashboard.module').then(m => m.NewSalesDashboardModule)
    },
    // {
    //   path: 'comboCode',
    //   loadChildren: () => import('./combo-code/combo-code.module').then(m => m.ComboCodeModule),
    // },
    {
      path: 'group-details',
      loadChildren: () => import('./group-details/group-details.module').then(m => m.GroupDetailsModule)
    },
    {
      path: 'all-quotes',
      loadChildren: () => import('./all-quotes/all-quotes.module').then(m => m.AllQuotesRoutingModule)
    },
    {
      path: 'enrollment-calculator',
      loadChildren: () => import('./enrollment-calculator/enrollment-calculator.module').then(m => m.EnrollmentCalculatorModule)
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
